(function () {
  'use strict';

  angular
      .module('tfc.sso')
      .controller('RecoverPasswordCtrl', RecoverPasswordCtrl);

  // @ngInject
  function RecoverPasswordCtrl($state, $stateParams, email, Auth, Toast, TextUtil) {
    var vm = this;

    vm.email = email;

    vm.submit = function () {
      Auth.recoverPassword($stateParams.t, vm.user.newPass).then(function () {
        Toast.success(TextUtil.translateOr('auth.password.reset.success', function () {
          return 'Your password has been reset.';
        }));
        $state.go('login');
      });
    };
  }

})();
